import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/api/queryKeys';
import { getGroups, type ListGroupsParams } from '@/api/groups';

/** Paginated groups query for the Directory Groups tab and KPI tiles. */
export function useGroups(params: ListGroupsParams = {}) {
  return useQuery({
    queryKey: queryKeys.groups.list(params as Record<string, unknown>),
    queryFn: () => getGroups(params),
  });
}
